<router-outlet></router-outlet>
<ng-http-loader
  [backdrop]="false"
  [entryComponent]="spinnerComponent"
  [backgroundColor]="'#ff0000'"
  [debounceDelay]="0"
  [extraDuration]="0"
  [minDuration]="0"
  [backdropBackgroundColor]="'#ffffff82'"
>
</ng-http-loader>


<!--<div class="wechat" *ngIf="!hasLoggedIn">-->
<!--  <div class="relative" style="display: inline-block;">-->
<!--    <div (click)="clickChat()" class="absolute top-8 left-24 w-24 h-24 cursor-pointer"></div>-->
<!--   <div class="p-2">-->
<!--     <iframe style="pointer-events: none;"  src="https://lottie.host/embed/abcb51ec-263e-45a8-89fa-f9a09a0c6f1a/SWVQudqOAv.lottie"></iframe>-->
<!--   </div>-->
<!--  </div>-->
<!--</div>-->

<!-- [filteredHeaders]="['ngloader']" -->
<!-- to be added to the ng-http-loader when exlude loader to some end point -->
